import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { ProductsService } from "./ProductsService";

export const SingleAirtimeRecharge = createAsyncThunk(
  "ls/SingleAirtimeRecharge",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await ProductsService.productsModule().SingleAirtime(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "An Error Occurred While Performing Operation"
      );
      //  exitReponse(error);
      return error;
    }
  }
);

export const BulkAirtimeRecharge = createAsyncThunk(
  "ls/BulkAirtimeRecharge",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await ProductsService.productsModule().BulkAirtime(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "An Error Occurred While Performing Operation"
      );
      //  exitReponse(error);
      return error;
    }
  }
);

export const SingleDataRecharge = createAsyncThunk(
  "ls/SingleDataRecharge",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await ProductsService.productsModule().SingleData(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "An Error Occurred While Performing Operation"
      );
      //  exitReponse(error);
      return error;
    }
  }
);

export const DataPlans = createAsyncThunk(
  "ls/DataPlans",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await ProductsService.productsModule().GetDataPlans(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      return error;
    }
  }
);

export const GetProviders = createAsyncThunk(
  "ls/GetProviders",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await ProductsService.productsModule().GetProviders(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      return error;
    }
  }
);

export const GetProducts = createAsyncThunk(
  "ls/GetProducts",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await ProductsService.productsModule().GetProducts(
        payload
      );
      return response?.data;
    } catch (error) {
      // toast.error(error?.response?.data?.message);
      return error;
    }
  }
);

export const VerifyMeter = createAsyncThunk(
  "ls/VerifyMeter",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await ProductsService.productsModule().VerifyMeter(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      return error;
    }
  }
);


export const VerifyCableTV = createAsyncThunk(
  "ls/VerifyMeter",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await ProductsService.productsModule().VerifyCable(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      return error;
    }
  }
);


export const SingleElectricity = createAsyncThunk(
  "ls/SingleElectricity",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await ProductsService.productsModule().SingleElectricity(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      return error;
    }
  }
);


export const SingleCable = createAsyncThunk(
  "ls/SingleElectricity",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await ProductsService.productsModule().SingleCable(
        payload
      );
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      return error;
    }
  }
);

export const ProductsSlice = createSlice({
  name: "Products",
  initialState: "",
  extraReducers: {
    [SingleDataRecharge.pending]: (state) => {
      return {
        ...state,
        loadingPlans: true,
      };
    },
    [SingleDataRecharge.fulfilled]: (state, action) => {
      return {
        ...state,
        plans: action.payload,
        loadingPlans: false,
      };
    },
    [SingleDataRecharge.rejected]: (state, action) => {
      return {
        ...state,
        loadingPlans: false,
        error: action.payload,
      };
    },

    [DataPlans.pending]: (state) => {
      return {
        ...state,
        loadingPlans: true,
      };
    },
    [DataPlans.fulfilled]: (state, action) => {
      return {
        ...state,
        plans: action.payload,
        loadingPlans: false,
      };
    },
    [DataPlans.rejected]: (state, action) => {
      return {
        ...state,
        loadingPlans: false,
        error: action.payload,
      };
    },

    [BulkAirtimeRecharge.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [BulkAirtimeRecharge.fulfilled]: (state, action) => {
      return {
        ...state,
        bulkAirtime: action.payload,
        loading: false,
      };
    },
    [BulkAirtimeRecharge.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [SingleAirtimeRecharge.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [SingleAirtimeRecharge.fulfilled]: (state, action) => {
      return {
        ...state,
        singleAirtime: action.payload,
        loading: false,
      };
    },
    [SingleAirtimeRecharge.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [GetProducts.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [GetProducts.fulfilled]: (state, action) => {
      return {
        ...state,
        products: action.payload,
        loading: false,
      };
    },
    [GetProducts.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [GetProviders.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [GetProviders.fulfilled]: (state, action) => {
      return {
        ...state,
        providers: action.payload,
        loading: false,
      };
    },
    [GetProviders.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [VerifyMeter.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [VerifyMeter.fulfilled]: (state, action) => {
      return {
        ...state,
        verifiedData: action.payload,
        loading: false,
      };
    },
    [VerifyMeter.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [SingleElectricity.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [SingleElectricity.fulfilled]: (state, action) => {
      return {
        ...state,
        verifiedData: action.payload,
        loading: false,
      };
    },
    [SingleElectricity.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },
  },
});

export default ProductsSlice.reducer;
